import { useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

function ShareLanding() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const payload = useMemo(() => {
    const url = searchParams.get('url') ?? ''
    const title = searchParams.get('title') ?? ''
    const text = searchParams.get('text') ?? ''
    const note = searchParams.get('note') ?? text
    const tags = searchParams.getAll('tag')
    const tagString = searchParams.get('tags')

    return {
      url,
      title,
      note,
      tags:
        tags.length > 0
          ? tags
          : tagString
              ? tagString
                  .split(',')
                  .map((tag) => tag.trim())
                  .filter(Boolean)
              : [],
    }
  }, [searchParams])

  useEffect(() => {
    if (!payload.url) {
      return
    }

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(
        'fts-share-draft',
        JSON.stringify({
          url: payload.url,
          title: payload.title,
          note: payload.note,
          tags: payload.tags,
        }),
      )
    }

    const params = new URLSearchParams()

    params.set('url', payload.url)

    if (payload.title) {
      params.set('title', payload.title)
    }

    if (payload.note) {
      params.set('text', payload.note)
    }

    if (payload.tags.length) {
      params.set('tags', payload.tags.join(','))
    }

    params.set('source', 'share-fallback')

    navigate({ pathname: '/', search: `?${params.toString()}` }, { replace: true })
  }, [payload, navigate])

  const helperText = payload.url
    ? 'Sending you to the dashboard so you can finish saving this link.'
    : 'No URL provided. Append ?url=https://example.com to share via GET.'

  return (
    <div style={{ maxWidth: '560px', margin: '0 auto', padding: '40px 20px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Processing shared link</h1>
      <p style={{ color: '#4f5b66', marginBottom: '24px' }}>{helperText}</p>
      {payload.url ? (
        <div style={{ background: '#f3f4f6', borderRadius: '12px', padding: '20px', textAlign: 'left' }}>
          <dl style={{ display: 'grid', gap: '12px', fontSize: '0.95rem', color: '#4f5b66' }}>
            <div>
              <dt style={{ fontWeight: 600 }}>URL</dt>
              <dd>
                <a href={payload.url} target="_blank" rel="noreferrer" style={{ color: '#0b1f33' }}>
                  {payload.url}
                </a>
              </dd>
            </div>
            {payload.title ? (
              <div>
                <dt style={{ fontWeight: 600 }}>Title</dt>
                <dd>{payload.title}</dd>
              </div>
            ) : null}
            {payload.note ? (
              <div>
                <dt style={{ fontWeight: 600 }}>Note</dt>
                <dd>{payload.note}</dd>
              </div>
            ) : null}
            {payload.tags.length ? (
              <div>
                <dt style={{ fontWeight: 600 }}>Tags</dt>
                <dd>{payload.tags.join(', ')}</dd>
              </div>
            ) : null}
          </dl>
        </div>
      ) : null}
    </div>
  )
}

export default ShareLanding
